import { render, staticRenderFns } from "./SeccionLecturas.vue?vue&type=template&id=85b7cca2&scoped=true"
import script from "./SeccionLecturas.vue?vue&type=script&lang=js"
export * from "./SeccionLecturas.vue?vue&type=script&lang=js"
import style0 from "./SeccionLecturas.vue?vue&type=style&index=0&id=85b7cca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b7cca2",
  null
  
)

export default component.exports